// extracted by mini-css-extract-plugin
export default {"counterBadge":"TodoCounter_counterBadge__vewoG"};